import React, { useState, useEffect } from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Send } from 'lucide-react';

// Déplace les sous-composants en dehors de Footer pour éviter leur recréation à chaque render
const getStyles = (isMobile) => ({
    footer: {
    background: 'linear-gradient(135deg, #0a0a0a 0%, #000000 100%)',
    color: '#ffffff',
    borderTop: '3px solid #c59b00',
    marginTop: 'auto',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: isMobile ? '3rem 1.5rem 2rem' : '4rem 2rem 2rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: isMobile ? '2.5rem' : '3rem',
    marginBottom: isMobile ? '2rem' : '3rem',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  sectionTitle: {
    fontSize: isMobile ? '1.3rem' : '1.5rem',
    fontWeight: '700',
    marginBottom: '0.5rem',
    color: '#ffffff',
    fontFamily: "'Montserrat', sans-serif",
    letterSpacing: '1px',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '1rem',
  },
  logoIcon: {
    background: 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)',
    padding: '0.8rem',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 15px rgba(197, 155, 0, 0.25)',
  },
  logoText: {
    fontSize: isMobile ? '1.1rem' : '1.4rem',
    fontWeight: '800',
    color: '#c59b00',
    letterSpacing: '1px',
    fontFamily: "'Poppins', 'Montserrat', sans-serif",
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1rem',
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
    padding: '0.5rem',
    borderRadius: '8px',
  },
  iconWrapper: {
    background: 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)',
    padding: '0.7rem',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 15px rgba(197, 155, 0, 0.25)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    flexShrink: 0,
  },
  contactText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.3rem',
  },
  contactLabel: {
    fontSize: '0.85rem',
    color: '#999999',
    fontWeight: '500',
  },
  contactValue: {
    fontSize: isMobile ? '0.9rem' : '1rem',
    color: '#ffffff',
    fontWeight: '400',
    wordBreak: 'break-word',
  },
  socialGrid: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
    gap: '1rem',
  },
  socialButton: {
  background: 'rgba(255, 255, 255, 0.05)',
  border: '2px solid rgba(197, 155, 0, 0.22)',
    borderRadius: '15px',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: isMobile ? 'center' : 'flex-start',
    gap: '0.8rem',
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: '500',
  },
  description: {
    fontSize: isMobile ? '0.95rem' : '1rem',
    lineHeight: '1.8',
    color: '#cccccc',
    marginTop: '0.5rem',
  },
  newsletterForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginTop: '1rem',
  },
  inputWrapper: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: isMobile ? 'column' : 'row',
  },
  input: {
    flex: 1,
    padding: '1rem',
    borderRadius: '12px',
  border: '2px solid rgba(197, 155, 0, 0.22)',
    background: 'rgba(255, 255, 255, 0.05)',
    color: '#ffffff',
    fontSize: '1rem',
    outline: 'none',
    transition: 'all 0.3s ease',
    fontFamily: "'Poppins', sans-serif",
  },
  submitButton: {
  background: 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)',
    border: 'none',
    borderRadius: '12px',
    padding: '1rem 2rem',
    color: '#000000',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    transition: 'all 0.3s ease',
    fontSize: '1rem',
    boxShadow: '0 4px 15px rgba(197, 155, 0, 0.25)',
    whiteSpace: 'nowrap',
  },
  successMessage: {
    background: 'rgba(76, 175, 80, 0.2)',
    border: '2px solid #4caf50',
    borderRadius: '12px',
    padding: '1rem',
    color: '#4caf50',
    textAlign: 'center',
    fontWeight: '600',
  },
  divider: {
    height: '2px',
    background: 'linear-gradient(90deg, transparent, #c59b00, transparent)',
    margin: isMobile ? '1.5rem 0' : '2rem 0',
  },
  bottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: isMobile ? '1.5rem' : '2rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    flexWrap: 'wrap',
    gap: '1rem',
    flexDirection: isMobile ? 'column' : 'row',
    textAlign: isMobile ? 'center' : 'left',
  },
  copyright: {
    color: '#999999',
    fontSize: isMobile ? '0.85rem' : '0.95rem',
  },
    highlight: {
    color: '#c59b00',
    fontWeight: '600',
  },
});

const SnapchatIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.206 2c2.967 0 5.134 2.263 5.134 5.344 0 1.18-.358 2.324-.994 3.28-.102.154-.218.293-.342.423-.028.03-.057.058-.087.086a.493.493 0 01-.094.068c-.118.072-.268.09-.403.045a1.654 1.654 0 00-.42-.053c-.342 0-.643.166-.82.433-.177.267-.177.606 0 .873.354.534.958.868 1.623.868.182 0 .36-.028.532-.082a.974.974 0 01.354-.065c.472 0 .902.323 1.02.795.03.122.046.249.046.377 0 .47-.217.912-.586 1.196-.736.567-1.736.88-2.816.88-.46 0-.917-.058-1.352-.172a6.426 6.426 0 01-1.103-.416c-.284-.13-.572-.252-.867-.364-.59-.224-1.21-.337-1.843-.337-.633 0-1.253.113-1.843.337-.295.112-.583.234-.867.364a6.426 6.426 0 01-1.103.416c-.435.114-.892.172-1.352.172-1.08 0-2.08-.313-2.816-.88-.369-.284-.586-.726-.586-1.196 0-.128.016-.255.046-.377.118-.472.548-.795 1.02-.795.12 0 .24.021.354.065.172.054.35.082.532.082.665 0 1.269-.334 1.623-.868.177-.267.177-.606 0-.873-.177-.267-.478-.433-.82-.433-.142 0-.282.018-.42.053a.493.493 0 01-.403-.045.493.493 0 01-.094-.068c-.03-.028-.059-.057-.087-.086a4.024 4.024 0 01-.342-.423 5.373 5.373 0 01-.994-3.28C6.66 4.263 8.827 2 11.794 2h.412z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
  </svg>
);

const ContactItem = ({ icon: Icon, label, value, href, styles }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      style={{
        ...styles.contactItem,
        transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
    background: isHovered ? 'rgba(197,155,0,0.08)' : 'transparent',
        textDecoration: 'none',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          ...styles.iconWrapper,
          transform: isHovered ? 'rotate(360deg) scale(1.1)' : 'rotate(0deg) scale(1)',
          boxShadow: isHovered
            ? '0 6px 25px rgba(197,155,0,0.45)'
            : '0 4px 15px rgba(197,155,0,0.25)',
        }}
      >
        <Icon size={20} color="#000000" />
      </div>
      <div style={styles.contactText}>
        <span style={styles.contactLabel}>{label}</span>
        <span style={styles.contactValue}>{value}</span>
      </div>
    </a>
  );
};

const SocialButton = ({ icon: Icon, name, href, styles }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        ...styles.socialButton,
        background: isHovered
          ? 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)'
          : 'rgba(255, 255, 255, 0.05)',
        borderColor: isHovered ? '#c59b00' : 'rgba(197, 155, 0, 0.22)',
        transform: isHovered ? 'translateY(-5px) scale(1.05)' : 'translateY(0) scale(1)',
        boxShadow: isHovered ? '0 8px 20px rgba(197,155,0,0.35)' : 'none',
        color: isHovered ? '#000000' : '#ffffff',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Icon size={24} />
      <span style={{ fontWeight: '600' }}>{name}</span>
    </a>
  );
};

const NewsletterForm = ({ email, setEmail, isSubscribed, handleSubscribe, styles }) => {
  const [buttonHovered, setButtonHovered] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);

  return (
    <div style={styles.newsletterForm}>
      <p style={styles.description}>
        Inscrivez-vous à notre newsletter pour recevoir nos meilleures offres et nouveautés !
      </p>
      {!isSubscribed ? (
        <div style={styles.inputWrapper}>
          <input
            type="email"
            placeholder="Votre adresse email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              ...styles.input,
              borderColor: inputFocused ? '#c59b00' : 'rgba(197, 155, 0, 0.22)',
              background: inputFocused ? 'rgba(197, 155, 0, 0.06)' : 'rgba(255, 255, 255, 0.05)',
            }}
            onFocus={() => setInputFocused(true)}
            onBlur={() => setInputFocused(false)}
          />
          <button
            onClick={handleSubscribe}
            style={{
              ...styles.submitButton,
              transform: buttonHovered ? 'translateY(-2px) scale(1.05)' : 'translateY(0) scale(1)',
              boxShadow: buttonHovered
                ? '0 6px 25px rgba(197,155,0,0.45)'
                : '0 4px 15px rgba(197,155,0,0.25)',
            }}
            onMouseEnter={() => setButtonHovered(true)}
            onMouseLeave={() => setButtonHovered(false)}
          >
            <Send size={20} />
            S'inscrire
          </button>
        </div>
      ) : (
        <div style={styles.successMessage}>
          ✓ Merci ! Vous êtes inscrit à notre newsletter
        </div>
      )}
    </div>
  );
};

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubscribe = (e) => {
    e && e.preventDefault && e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      setTimeout(() => {
        setIsSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  const styles = getStyles(isMobile);

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.grid}>
          <div style={styles.section}>
            <div style={styles.logoContainer}>
              <img src="/logo.jpg" alt="Destockmax logo" style={{ width: isMobile ? '48px' : '64px', height: isMobile ? '48px' : '64px', objectFit: 'contain', borderRadius: '8px' }} />
              <div style={styles.logoText}>DESTOCKMAX</div>
            </div>
            <p style={styles.description}>
              Votre spécialiste en palettes de produits d'hygiène de qualité. 
              Nous proposons des solutions économiques pour professionnels et particuliers 
              avec un service client exceptionnel.
            </p>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Contact</h3>
            <ContactItem
              icon={Phone}
              label="Téléphone"
              value="+33 6 44 66 35 83"
              href="tel:+33644663583"
              styles={styles}
            />
            <ContactItem
              icon={Mail}
              label="Email"
              value="destock.max@outlook.com"
              href="mailto:destock.max@outlook.com"
              styles={styles}
            />
            <ContactItem
              icon={MapPin}
              label="Adresse"
              value="4 Rue Du Bouguen, Brest"
              href="https://maps.google.com/?q=4+Rue+Du+Bouguen+Brest"
              styles={styles}
            />
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Suivez-nous</h3>
            <div style={styles.socialGrid}>
              <SocialButton icon={Facebook} name="Facebook" href="https://www.facebook.com/share/1DE4X2SAem/?mibextid=wwXIfr" styles={styles} />
              <SocialButton icon={SnapchatIcon} name="Snapchat" href="https://www.snapchat.com/add/destokmax?share_id=aY9ELeooSueUnMFRSfCJ3Q&locale=fr_FR" styles={styles} />
              <SocialButton icon={Instagram} name="Instagram" href="https://www.instagram.com/destokmax?igsh=MTV1Ynd2aGg3YjR4bA%3D%3D&utm_source=qr" styles={styles} />
              <SocialButton icon={TikTokIcon} name="TikTok" href="https://www.tiktok.com/@destokmax?_t=ZM-90lRl2vqKKW&_r=1" styles={styles} />
            </div>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Newsletter</h3>
            <NewsletterForm
              email={email}
              setEmail={setEmail}
              isSubscribed={isSubscribed}
              handleSubscribe={handleSubscribe}
              styles={styles}
            />
          </div>
        </div>

        <div style={styles.divider} />

        <div style={styles.bottom}>
          <p style={styles.copyright}>
            © 2025 <span style={styles.highlight}>DESTOCKMAX</span>. Tous droits réservés.
          </p>
          <p style={styles.copyright}>
            Fait avec soin pour des palettes de qualité
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;